import { combineReducers } from 'redux';
import exchangeVariantsReducer from './exchangeVariants/reducers';
import passengersReducer from './passengers/reducers';
import segmentsReducer from './segments/reducers';
import errorReducer from './error/reducers';
import paymentStatusReducer from './paymentStatus/reducers';
import isLoadingReducer from './isLoading/reducers';
const rootReducer = combineReducers({
    exchangeVariants: exchangeVariantsReducer,
    passengers: passengersReducer,
    segments: segmentsReducer,
    error: errorReducer,
    paymentStatus: paymentStatusReducer,
    isLoading: isLoadingReducer
});
export default rootReducer;
